// Landing page theme based on PJMF branding
export const landingTheme = {
  fonts: {
    primary:
      '"Proxima Nova", "Raleway", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    heading:
      '"Raleway", "Proxima Nova", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body: '"Proxima Nova", "Raleway", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  colors: {
    primary: '#007D99', // PJMF Teal (Primary)
    secondary: '#FAE6BB', // PJMF Light Orange (Secondary light - for background fade icons)
    darkTeal: '#005771', // PJMF Dark Teal (Secondary dark - for footer)
    // Additional McGovern brand colors
    gold: '#FFC719', // McGovern Gold
    accent: '#DE8B39', // McGovern Rust
    lime: '#C2CE51', // McGovern Lime
    lightTeal: '#CBDCE1', // McGovern Light Teal
    lightLime: '#EEF2C2', // McGovern Light Lime
    black: '#231F20',
    white: '#FFFFFF',
    gray: '#A7A9AC',
    lightGray: '#E6E7E8',
  },
  gradients: {
    hero: 'linear-gradient(180deg, #007D99 0%, #005771 100%)',
    pricing: 'linear-gradient(135deg, #007D99 0%, #005771 100%)',
    footer: 'linear-gradient(to right, #FAE6BB, #EEF2C2)',
    border: 'linear-gradient(to right, #FFC719 21%, #DE8B39 60%, #007D99 100%)',
  },
};
